export const imageFileExtensions = ["jpg", "jpeg", "png"];
export const documentFileExtensions = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx"
];

export const getFileExtension = fileName => {
  const ext = fileName.substring(fileName.lastIndexOf(".") + 1);
  return (ext || "").toLocaleLowerCase();
};

export const isImage = filename =>
  imageFileExtensions.indexOf(getFileExtension(filename)) >= 0;

export const dataURItoBlob = dataURI => {
  const binary = atob(dataURI.split(",")[1]);
  const array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: "image/png" });
};
